__webpack_require__.p = "/apps/holiday_calendars/js/";